import { jsx as _jsx } from "react/jsx-runtime";
import { createBlockContextProvider } from './context';
import { createEditorController } from './editorController';
export function createEditor(config, enhancer) {
    return create({
        ...config,
        adapter: config.adapter,
    }, enhancer);
}
function create(config, enhancer) {
    if (enhancer) {
        // @ts-expect-error
        return enhancer(create)(config);
    }
    const context = createBlockContextProvider();
    const adapter = config.adapter.create({
        context,
        debounceDelayMs: config.debounceDelayMs,
    });
    const { Component: AdapterComponent } = adapter;
    return {
        context,
        Component(props) {
            const { as: Theme } = props;
            // NOTE this is temp solution. the adapter should not need to care
            // about the type of the custom component types
            const themeCasted = Theme;
            const adapterProps = adapter.controller.useProps({
                state: props.state,
                as: themeCasted,
                onUpdate: props.onUpdate,
                onSelect: props.onSelect,
                suggestion: props.suggestion ?? undefined,
                onMount: props.onMount,
                onSuggestionUpdate: props.onSuggestionUpdate,
            });
            return (_jsx(AdapterComponent, { as: themeCasted, ...adapterProps, suggestion: props.suggestion ?? undefined }));
        },
        controller: createEditorController(adapter.controller),
    };
}
//# sourceMappingURL=editorProvider.js.map